import { Link } from "react-router-dom";
import WebinarCard from "../EventsSection/WebinarCard";
import { webinarRepository } from "../../webinars/repository";
import { useRepositoryData } from "../../webinars/useRepositoryData";
import { availability, upcomingWebinars } from "../../webinars/availability";
import { presenterPhotoUrl } from "../../webinars/photos";

const NEWS_PAGE_COUNT = 3;

// The next few webinars open for registration, for the news page. Full or closed sessions,
// past events and recordings are only on /events.
const UpcomingEvents = () => {
    const { data, loading, error } = useRepositoryData(async () => {
        const [webinars, counts] = await Promise.all([
            webinarRepository.listPublicWebinars(),
            webinarRepository.countActiveRegistrations(),
        ]);
        return { webinars, counts };
    }, "news-upcoming");

    // Only webinars people can still register for: not started, deadline not passed, not full, not closed
    const now = Date.now();
    const upcoming = upcomingWebinars(data?.webinars ?? [], now)
        .filter(w => availability(w, data?.counts[w.id] ?? 0, now).canRegister)
        .slice(0, NEWS_PAGE_COUNT);

    return (
        <section className="km-section km-section--alt" id="events" aria-labelledby="nw-events-title">
            <div className="km-container">
                <div className="nw-sectionHead" data-reveal>
                    <div>
                        <h2 className="km-title" id="nw-events-title">Upcoming events</h2>
                        <p className="km-lead">
                            Live webinars on medical devices and regulatory compliance. Times are South African
                            Standard Time (SAST).
                        </p>
                    </div>
                    <Link className="km-link" to="/events">
                        See all events <span className="km-arrow" aria-hidden="true">→</span>
                    </Link>
                </div>

                {loading && !data ? (
                    <p className="nw-events-note" role="status">Loading upcoming events…</p>
                ) : error ? (
                    // The events page has the full error help; here a short note is enough
                    <p className="nw-events-note">
                        Upcoming events couldn't be loaded right now. <Link to="/events">See them on the events page</Link>.
                    </p>
                ) : upcoming.length > 0 ? (
                    <div className="km-cardRow">
                        {upcoming.map((webinar, index) => (
                            <WebinarCard
                                key={webinar.id}
                                webinar={webinar}
                                activeCount={data?.counts[webinar.id] ?? 0}
                                presenterPhotoUrl={presenterPhotoUrl(webinar.presenterPhoto)}
                                revealOrder={index}
                            />
                        ))}
                    </div>
                ) : (
                    <p className="nw-events-note">
                        No webinars are open for registration right now. Check back soon, or{" "}
                        <Link to="/query">ask us about upcoming sessions</Link>.
                    </p>
                )}
            </div>
        </section>
    );
};

export default UpcomingEvents;
